<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <br />
  <a-card title="Inclusão Indicação TAF">
    <div class="row">
      <label>Consultar Milítar</label>
      <div class="col-md-6 d-flex justify-content-left">
        <a-tooltip placement="top" title="Informe o nome, CPF ou RG Militar do Beneficiário" arrow-point-at-center>
          <a-auto-complete v-model:value="responseDadosMilitar.nome" class="form-control" :disabled="encontrado" @search="pesquisarDadosMilitarPeloNomeOuRg">
            <template v-slot:dataSource>
              <a-select-option v-for="item in dataPacientes" :key="item.nome" @click="onSelect(item)"> {{ item.cpf }} - {{ item.nome }} {{ item.rgMilitar }} </a-select-option>
            </template>
          </a-auto-complete>
        </a-tooltip>
        <a-tooltip placement="top" title="Limpar Consulta" arrow-point-at-center>
          <button @click="limpar()" style="margin-left: 4px" class="btn btn-icon-button" type="button"><i class="fa fa-eraser"></i></button>
        </a-tooltip>
      </div>
    </div>
  </a-card>
  <br />
  <a-card v-if="encontrado">
    <PageDadosMilitar v-model:dadosMilitar="responseDadosMilitar" />
  </a-card>
  <br />
  <a-card v-if="encontrado">
    <fieldset>
      <legend style="width: 160px">Agendamento</legend>
      <div class="row">
        <div class="col-md-12">
          <label>Restrições:</label>
          <div class="input-group input-focus">
            <a-checkbox-group v-model:value="registro.restricoes">
              <a-checkbox value="BARRA" name="type">BARRA</a-checkbox>
              <a-checkbox value="ABDOMINAL" name="type">ABDOMINAL</a-checkbox>
              <a-checkbox value="FLEXAO" name="type">FLEXÃO</a-checkbox>
              <a-checkbox value="CORRIDA" name="type">CORRIDA</a-checkbox>
            </a-checkbox-group>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-3">
          <label>Data do Agendamento:</label>
          <div class="input-group input-focus">
            <a-date-picker show-time type="date" placeholder="Ex: 20/02/2023" style="width: 100%" format="DD/MM/yyyy" v-model:value="registro.dataAgendamento" />
          </div>
        </div>
      </div>
    </fieldset>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-12">
        <button @click="cadastrar()" class="btn btn-primary" type="button"><i class="fa fa-save"></i> Incluir</button>
        <button type="button" style="margin-left: 4px" class="btn btn-primary" @click="limpar()"><i class="fa fa-eraser"> </i> Limpar</button>
      </div>
    </div>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import PageDadosMilitar from '@/components/pages/PageDadosMilitar';
import { getPaciente } from '@/components/service/pacienteService';
import { create } from '@/components/service/agendamentoTafService';
export default {
  name: 'PageInclusaoIndicacaoTAF',
  components: {
    PageDadosMilitar,
  },

  setup() {
    return {};
  },
  data() {
    return {
      encontrado: false,
      registro: {},
      dataPacientes: [],
      responseDadosMilitar: {},
      PageDadosMilitar: PageDadosMilitar,
    };
  },

  methods: {
    async pesquisarDadosMilitarPeloNomeOuRg(value) {
      if (value.length > 3) {
        await getPaciente({ any: value }).then((r) => {
          this.dataPacientes = r.data.pacientes;
        });
      } else {
        this.dataPacientes = [];
      }
    },

    limpar() {
      this.responseDadosMilitar = {};
      this.dataPacientes = [];
      this.encontrado = false;
      this.registro = {};
    },

    onSelect(value) {
      this.responseDadosMilitar = { ...value };
      setTimeout(() => {
        this.encontrado = true;
      }, 1);
    },
    async cadastrar() {
      if (!this.registro.dataAgendamento) {
        openNotification(typesNotification.warning, 'Você deve informar a data de agendamento!');
      } else {
        let registroPost = { ...this.registro };
        registroPost.paciente = { ...this.responseDadosMilitar };
        console.log(this.responseDadosMilitar);
        await create(registroPost).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = true;
          this.registro = {};
        });
      }
    },
  },
  created() {},
};
</script>

<style></style>
